module.exports = __webpack_public_path__ + "static/media/PATS_4-1018w.75eb030d.png";